<h1 class="text-center">{{ 'PD_COLLECT_DATA.HEADER.COMPLETE_FORM' | translate }}</h1>
<p class="text-center">{{ 'PD_COLLECT_DATA.TEXT.COMPLETE_FORM_DISCLAIMER' | translate }}</p>
<form [formGroup]="formGroup" (ngSubmit)="submit()" class="flex flex-column gap-3">
  <div class="flex flex-column gap-2">
    <label for="companyName">{{ 'PD_COLLECT_DATA.LABEL.COMPANY_NAME' | translate }}</label>
    <input pInputText formControlName="companyName" id="companyName" />
  </div>
  <div class="flex flex-column gap-2">
    <label for="businessNumber">{{ 'PD_COLLECT_DATA.LABEL.BUSINESS_NUMBER' | translate }}</label>
    <input pInputText formControlName="businessNumber" id="businessNumber" type="number" />
  </div>
  <div class="flex flex-column gap-2">
    <label for="address">{{ 'PD_COLLECT_DATA.LABEL.COMPANY_ADDRESS_CITY' | translate }}</label>
    <input pInputText formControlName="addressCity" id="address" />
  </div>
  <div class="flex flex-column gap-2">
    <label for="street">{{ 'PD_COLLECT_DATA.LABEL.COMPANY_ADDRESS_STREET' | translate }}</label>
    <input pInputText formControlName="addressStreet" id="street" />
  </div>
  <div class="flex flex-column gap-2">
    <label for="streetNumber">{{ 'PD_COLLECT_DATA.LABEL.COMPANY_ADDRESS_STREET_NUMBER' | translate }}</label>
    <input pInputText formControlName="addressNumber" id="streetNumber" />
  </div>
  <div class="flex flex-column gap-2">
    <label for="vendorNumber">{{ 'PD_COLLECT_DATA.LABEL.CREDIT_VENDOR_NUMBER' | translate }}</label>
    <input pInputText formControlName="vendorNumber" id="vendorNumber" />
  </div>
  <div class="flex flex-column gap-2">
    <label for="phone">{{ 'PD_COLLECT_DATA.LABEL.PHONE' | translate }}</label>
    <ngx-intl-tel-input
      formControlName="phone"
      id="phone"
      [preferredCountries]="[CountryISO.Israel]"
      [selectedCountryISO]="CountryISO.Israel"
      [numberFormat]="PhoneNumberFormat.National"
      [phoneValidation]="false"
    ></ngx-intl-tel-input>
  </div>

  <div class="flex justify-content-between">
    <button
      pButton
      pRipple
      (click)="goBack()"
      *ngIf="showBackButton"
      type="button"
      icon="pi pi-arrow-left"
      class="p-button-rounded"
    ></button>
    <button pButton class="simple-button" [ngClass]="{ 'w-9': showBackButton, 'w-12': !showBackButton }" [disabled]="formGroup.invalid">
      {{ 'PD_COLLECT_DATA.LABEL.CONTINUE' | translate }}
    </button>
  </div>
</form>
